import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { DomSanitizer, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

@Component({
selector: 'youtube-iframe',
	templateUrl: "./youtube-iframe.html",
	styles: [require("./youtube-iframe.scss")]
})

export class YoutubeIframe {
	protected safeUrl: SafeResourceUrl
	@Input()
	set videoId(videoId: string) {
		if (videoId) {
			this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + videoId)
		} else {
			this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/ABCDEFGHIKL")
		}
	}

	constructor(private sanitizer: DomSanitizer) {
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/youtube-iframe/youtube-iframe.component.ts